import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { SliceCaseReducers } from '@reduxjs/toolkit/dist/createSlice';
import { GiftCardBasketItem } from '../../services/exports/Interfaces';
import { StoreInterface } from '../types';

type InitialState = Readonly<{
  item?: GiftCardBasketItem;
}>;

const initialState: InitialState = {
  item: undefined,
} as const;

const giftCardsBasketSlice = createSlice<InitialState, SliceCaseReducers<InitialState>>({
  name: REDUX_STORE_SLICES.GIFT_CARDS_BASKET,
  initialState,
  reducers: {
    addToBasket: (draft, action: PayloadAction<GiftCardBasketItem>): void => {
      draft.item = action.payload;
    },
    reset: () => initialState,
  },
});

export const selectGiftCardsBasket = (state: StoreInterface) => state[REDUX_STORE_SLICES.GIFT_CARDS_BASKET].item;

export default giftCardsBasketSlice;
